import { Component } from '@angular/core';
import { AbstractFieldComponent } from '../abstract-field.component';

@Component( {
    selector: 'erp-pbw-email',
    templateUrl: './input-field.component.html'
} )
export class EmailAdressComponent extends AbstractFieldComponent<string>   {

    constructor() {
        super( 'rm.erp.jobapplication.JobApplication.emailaddress' );
    }

    set value( t: string | undefined ) {
        if ( this.jobapplication != null ) {
            this.jobapplication.emailaddress = t;
        }
    }

    get value(): string | undefined {
        return this.jobapplication?.emailaddress;
    }
}
